import { create } from 'zustand';

// Definiamo un'interfaccia (anche se non strettamente necessario in JS puro)
// per dare un'idea di cosa contiene lo store:
// {
//   count: number,
//   username: string,
//   increment: () => void,
//   decrement: () => void,
//   setUserName: (newName: string) => void
// }

export const useStore = create((set) => ({
    // Stato iniziale (Initial State)
    dests: [],
    datiDottorando: null,
    idConfig: null,

    // Azioni (Actions) per modificare lo stato
    // La funzione `set` viene usata per aggiornare lo stato.
    setDests: (newDests) => set(() => ({ dests: newDests })),
    clearDests: () => set(() => ({ dests: [] })),
    setDatiDottorando: (data) => set(() => ({ datiDottorando: data })),
    clearDatiDottorando: () => set(() => ({ datiDottorando: null })),
    setIdConfig: (id) => set(() => ({ idConfig: id })),
    clearIdConfig: () => set(() => ({ idConfig: null })),

}));